import type { AppStore } from "@/app/store"
import api from "@/services/api"
import { logOut, setLoginSheetOpen } from "@/features/auth/authSlice"
import type { AxiosError, InternalAxiosRequestConfig } from "axios"

export const setupInterceptors = (store: AppStore) => {
  // 요청 인터셉터: 모든 요청에 인증 토큰 추가
  api.interceptors.request.use(
    config => {
      const token = store.getState().auth.accessToken
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => Promise.reject(error instanceof Error ? error : new Error(String(error))),
  )

  api.interceptors.response.use(
    response => response,
    async (error: AxiosError) => {
      const originalRequest = error.config as (InternalAxiosRequestConfig & { _retry?: boolean }) | undefined

      // 401 Unauthorized 발생 시
      if (error.response?.status === 401 && originalRequest) {
        // 무한 루프 방지 (이미 재시도된 요청이면 무시)
        if (originalRequest._retry) {
          return Promise.reject(error)
        }
        originalRequest._retry = true

        // Race Condition 체크:
        // 현재 스토어의 토큰과 이 요청에서 사용된 토큰이 다르면,
        // 이미 새로운 토큰이 설정된 것이므로 로그아웃 처리를 하지 않음.
        const currentToken = store.getState().auth.accessToken
        const authHeader = originalRequest.headers.Authorization
        const requestToken = typeof authHeader === "string" ? authHeader.replace("Bearer ", "") : null

        if (currentToken && requestToken && currentToken !== requestToken) {
          console.warn("401 error from an old token. Ignoring because a new token is already set.")
          return Promise.reject(error)
        }

        console.error("401 Unauthorized - Redirecting to login.")

        // 로그아웃 처리 (토큰 삭제 등)
        store.dispatch(logOut())

        // 로그인 액션 시트(`LoginActionSheet`) 열기
        store.dispatch(setLoginSheetOpen(true))
      }

      return Promise.reject(error)
    },
  )
}
